<template>
    <c-dialog ref="dialog" width="600" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="单据编号">
                <c-input name="document_number" placeholder="不填将自动生成"></c-input>
            </c-form-item>

            <c-form-item label="紧急程度" required>
                <c-radio-group name="emergency_level" :options="urgencyLevelDic" :value="1"></c-radio-group>
            </c-form-item>

            <c-form-item label="加班方式" required>
                <c-radio-group name="overtime_type" v-model="overtime_type" :options="overtimeTypeDic"></c-radio-group>
            </c-form-item>

            <c-form-item label="关联售后工单" v-if="overtime_type == 1" required>
                <c-select name="order_id" v-model="order_id" async @search="searchAftersaleOrder" :value-data="orderOptions" :clear="false"></c-select>
                <info-card code="AFTERSALE_ORDER" :id="order_id"></info-card>
            </c-form-item>

            <c-form-item label="加班事由" v-if="overtime_type != 1" required>
                <c-input name="reason" type="textarea" maxlength="500" :rows="3" placeholder="说明写这里..."></c-input>
            </c-form-item>
            <c-form-item label="加班凭证" v-if="overtime_type != 1">
                <c-upload-file name="voucher_images" type="image" :limit="5" button="上传" media></c-upload-file>
            </c-form-item>

            <c-title style="margin-top: 16px;">加班明细</c-title>
            <div class="item-list">
                <div v-for="(item, index) in itemList" :key="index" class="item-row">
                    <c-form :ref="'itemForm' + index" class="item-form">
                        <div class="flex-wrap">
                            <c-form-item label="加班开始时间" class="item-field" required>
                                <c-datetime v-model="item.start_date" type="datetime" format="yyyy-MM-dd hh:mm" placeholder="请选择加班开始时间"></c-datetime>
                            </c-form-item>
                            <c-form-item label="加班结束时间" class="item-field" required>
                                <c-datetime v-model="item.end_date" type="datetime" format="yyyy-MM-dd hh:mm" placeholder="请选择加班结束时间"></c-datetime>
                            </c-form-item>
                            <c-form-item :label="false" class="item-field item-field-btn">
                                <c-button icon="tf-trash" type="text" @click="removeItem(index)">删除</c-button>
                            </c-form-item>
                        </div>
                    </c-form>
                </div>
                <c-button color="main" prepend-icon="tf-add" @click="addItem" size="dialog">添加加班明细</c-button>
            </div>
        </c-form>
        <template #button>
            <c-button size="form" v-if="!editState || order_status == -1" @click="submitHandle(-1)">暂存</c-button>
            <c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
        </template>
        <workflow-launch ref="workflowLaunch"></workflow-launch>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
import workflowLaunch from "@/components/service/workflow_launch.vue";

export default {
    components: {workflowLaunch},
    computed: {
        ...mapState(['urgencyLevelDic', 'overtimeTypeDic','overtimeTypeOption', 'timePeriodDic'])
    },
    data() {
        return {
            order_status: -1,
            editState: false,
            order_id: 0,
            overtime_type:1,        //工单加班
            orderOptions: [],
            itemList: []
        }
    },

    methods: {
        async open(data) {
            this.$refs.form.clear();
            this.editState = false;
            this.order_id = 0;
            this.orderOptions = [];

            if (data) {
                this.request({
                    url: '/overtime/application/detail',
                    data: {id: data.id},
                    success: res => {
                        const detailData = res.detailInfo || {};
                        this.order_status = detailData.status || -1;
                        this.itemList = detailData.detail_list || [];
                        this.$refs.form.set(detailData);
                        if (detailData.order_id && detailData.order_number) {
                            this.orderOptions = [{
                                name: detailData.order_number,
                                value: detailData.order_id
                            }];
                        }
                    }
                });
                this.editState = true;
            } else {
                this.$refs.form.set({
                    emergency_level: 1,
                    overtime_type: this.overtime_type
                });
                this.addItem();
            }

            this.$refs.dialog.open({
                title: this.editState ? '编辑加班申请' : '发起加班申请'
            });
        },
        searchAftersaleOrder(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code:'AFTERSALE_ORDER',
                    is_member:1,        //仅查询当前用户参与的工单
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },

        addItem() {
            this.itemList.push({
                start_time: null,        //加班时间
                end_time: null,
                overtime_type: ''
            });
        },

        removeItem(index) {
            this.itemList.splice(index, 1);
        },

        submitHandle(status) {
            this.$refs.form.submit({
                url: this.editState ? '/overtime/application/update' : '/overtime/application/add',
                rule: {
                    overtime_type: '请选择加班方式',
                    order_id: [{
                        type: 'empty',
                        message: '请选择关联售后工单',
                        skip: () => {
                            return this.overtime_type != 1;
                        }
                    }],
                    reason: [{
                        type: 'empty',
                        message: '请填写加班事由',
                        skip: () => {
                            return this.overtime_type != 2;
                        }
                    }],
                    detail_list: data => {
                        var flag = true;
                        if(this.itemList.length == 0){
                            flag = false;
                            return '请至少添加一条加班明细';
                        }
                        this.itemList.forEach(item => {
                            if (!item.start_date || !item.end_date) {
                                flag = false;
                                return '请选择加班时间';
                            }
                            if (item.start_date > item.end_date) {
                                flag = false;
                                return '加班结束时间不能早于开始时间';
                            }
                        });

                        if (!flag) {
                            return "请完善加班明细";
                        }
                        return flag;
                    }
                },
                dataFormatter: data => {
                    const items = this.itemList.map(it => {
                        if (!it.start_date) {
                            this.$message({message: '请选择加班开始时间', type: 'warning'});
                            return;
                        }
                        if (!it.end_date) {
                            this.$message({message: '请选择加班结束时间', type: 'warning'});
                            return;
                        }
                        return {
                            start_date: it.start_date,
                            end_date: it.end_date
                        };
                    })
                    data.status = status;
                    data.detail_list = items;
                    return data;
                },
                success: (data, res) => {
                    if (status == 1 && res.transaction) {
                        this.$refs.workflowLaunch.launch(res.transaction, () => {
                            this.$refs.dialog.close();
                            this.$message({message: this.editState ? '编辑成功' : '新增成功', type: 'success'});
                            this.$emit('resolve');
                        });
                    } else {
                        this.$refs.dialog.close();
                        this.$message({message: this.editState ? '编辑成功' : '新增成功', type: 'success'});
                        this.$emit('resolve');
                    }
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.datetime-row {
    align-items: center;
}
.item-list {
    margin-top: 8px;
}
.item-row {
    margin-bottom: 12px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
}
.item-form >>> .c-form-item {
    margin-bottom: 8px;
}
.flex-wrap {
    width:70%;
}
.item-field {
    flex: 1;
    min-width: 120px;
}
.item-field-upload {
    min-width: 140px;
}
.item-field-btn {
    flex: none;
    min-width: 60px;
}
</style>

